@if (rating) {
<article class="compliance-rating">
	<div class="rating-container">
		<div class="rating rating-container-content">
			<div class="ico-size" [ngClass]="getIconClasses()">
				<i class="ico"></i>
				<i class="ico"></i>
				<i class="ico"></i>
			</div>
			@if (rating) {
			<span translate="{{ translateMap[rating.rating] }}"></span>
			}&nbsp; @if (rating.derived) {
			<span translate="process.compliance.rating.derived"></span>
			}
		</div>
		<stages-menu
			class="action"
			[menuId]="$any(ratingMenuItems)"
			iconClasses="ico ico-more-vertical"
			[items]="ratingMenuItems"
			openTo="left"
		></stages-menu>
	</div>
</article>
} @if (rating) {
<article class="compliance-rating comments subsection">
	<header>
		<div class="wrapper">
			<h5><span translate="compliance.rating.notes"></span></h5>
			<stages-menu
				[menuId]="$any(commentMenuItems)"
				class="action"
				iconClasses="ico ico-more-vertical"
				openTo="bottom"
				[items]="commentMenuItems"
			></stages-menu>
		</div>
	</header>
	<div class="rating-comment-container">
		<div class="rating-container-content">
			@if (!editEnabled && isEmpty()) {
			<div>
				<p class="rating-container-comments-content-empty" translate="none"></p>
			</div>
			} @if (!editEnabled && !isEmpty()) {
			<div class="rating-container-comments-content">{{ comment }}</div>
			} @if (editEnabled) {
			<div class="rating-container-comments-content description">
				<textarea
					class="text plaintext-input"
					[(ngModel)]="comment"
					tabindex="30"
					stagesAutoGrow
					stagesAutofocus
				></textarea>
				<div class="buttons">
					<button class="sm cancel" (click)="cancel()" translate="cancel"></button>
					<button class="sm save" (click)="saveComment()" translate="save"></button>
				</div>
			</div>
			}
		</div>
	</div>
</article>
} @if (!rating) {
<article class="description">
	<p translate="process.compliance.rating.invisible"></p>
</article>
}
